<template>
  <div
    id="app"
    class="app"
    :class="{ app_back_move: isBackMove }"
    :style="{ height: `${height}px` }"
  >
    <transition name="section-slide">
      <router-view/>
    </transition>
    <TheHeader
      class="app__header"
      data-animation="fadeInTop"
      data-animation-delay="1500"
    />
    <TheFooter
      class="app__footer"
      data-animation="fadeInBottom"
    />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import platform from 'platform';

import TheHeader from '@/components/TheHeader.vue';
import TheFooter from '@/components/TheFooter.vue';

export const ACTION_NAMES = Object.freeze({
  PREV: 'prev',
  NEXT: 'next',
});

export const PLATFORM = platform.os.family;

export default {
  name: 'App',
  components: {
    TheHeader,
    TheFooter,
  },
  data() {
    return {
      width: 0,
      height: 0,
    };
  },
  computed: {
    ...mapState(['isBackMove']),
  },
  created() {
    window.addEventListener('orientationchange', this.setSize);
    window.addEventListener('resize', this.setSize);
    this.setSize();
    this.fetchReviews();
  },
  beforeDestroy() {
    window.removeEventListener('orientationchange', this.setSize);
    window.removeEventListener('resize', this.setSize);
  },
  methods: {
    ...mapMutations(['setOrientation']),
    ...mapActions(['fetchReviews']),
    setSize() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
      this.setOrientation(this.height > this.width ? 'portrait' : 'landscape');
    },
  },
};
</script>

<style lang="stylus">
@import '~@/assets/stylus/fonts'
@import '~@/assets/stylus/normalize'
@import '~@/assets/stylus/keyframes'
@import '~@/assets/stylus/blocks'

.app
  position relative
  display block
  width 100%
  height 100%
  font-family $f_family, system-ui, sans-serif
  font-size calc(1.2vw + 2vh)
  font-weight 400
  line-height 1
  color $c_text
  overflow hidden
  +landscape()
    font-size calc(1vw + 1vh)

  &__layout
    margin 0 auto
    padding 0 1.4em
    +landscape()
      max-width 40em
      padding 0 2em
      .section_wide &
        max-width 52em

  &__sep
    display block
    height 1px
    border 0
    padding 0
    background-color alpha($c_border, 35%)
    margin 2.6em 0

  &__header
    fix top left right
    z-index 10
    +landscape()
      pointer-events none

  &__footer
    fix bottom left right
    animation-delay 2000ms
    z-index 10
    +portrait()
      display block
      animation-delay 100ms
      .section_down ~ &
        display none
    +landscape()
      fix bottom left right
      z-index 10

  &__modal
    fix top left right bottom
    z-index 100
    animation fadeIn 250ms ease both
</style>
